import {HttpClient} from '@angular/common/http'
import {inject, Service} from '@angular/core'
import {SparbankenUser} from '@sparbanken-syd/sparbanken-syd-bankid'
import {map} from 'rxjs'
import {environment} from '../../environments/environment'

@Service()
export class UserService {
  private readonly http = inject(HttpClient)

  public getUsers() {
    const url = `${environment.authServiceUrl}/users`
    return this.http.get<SparbankenUser[]>(url)
  }

  /**
   * Retrieves all offices of the Sparbanken.
   */
  public getOffices() {
    const url = `${environment.authServiceUrl}/data/offices`
    return this.http.get<string[]>(url)
      .pipe(
        map(offices => offices.toSorted((a, b) => a.localeCompare(b)))
      )
  }

}
